import { create } from 'zustand'
import type { User } from '@/types'

interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  isLoading: boolean

  setAuth: (user: User, token: string) => void
  logout: () => void
  setUser: (user: User) => void
  setLoading: (loading: boolean) => void
  hydrate: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: null,
  isAuthenticated: false,
  isLoading: true,

  setAuth: (user: User, token: string) => {
    localStorage.setItem('synapsios_token', token)
    localStorage.setItem('synapsios_user', JSON.stringify(user))
    set({ user, token, isAuthenticated: true, isLoading: false })
  },

  logout: () => {
    localStorage.removeItem('synapsios_token')
    localStorage.removeItem('synapsios_user')
    set({ user: null, token: null, isAuthenticated: false, isLoading: false })
  },

  setUser: (user: User) => {
    localStorage.setItem('synapsios_user', JSON.stringify(user))
    set({ user })
  },

  setLoading: (loading: boolean) => set({ isLoading: loading }),

  hydrate: () => {
    const token = localStorage.getItem('synapsios_token')
    const userStr = localStorage.getItem('synapsios_user')
    if (token && userStr) {
      try {
        const user = JSON.parse(userStr) as User
        set({ user, token, isAuthenticated: true, isLoading: false })
      } catch {
        localStorage.removeItem('synapsios_token')
        localStorage.removeItem('synapsios_user')
        set({ isLoading: false })
      }
    } else {
      set({ isLoading: false })
    }
  },
}))
